// Approving a payout batch is a one-click button on a card, so it asks first, the way Revert already does
// (triage FE-06-29). The password step that follows for a batch's own creator is separate and unchanged.
export function approveAfterConfirm(batch, ask, approve) {
  if (!batch) return false;
  const people = batch.employee_count === 1 ? "1 employee" : `${batch.employee_count ?? 0} employees`;
  if (!ask(`Approve Batch ${batch.batch_number} for payout (${people})?`)) return false;
  approve(batch.id);
  return true;
}

// The account a batch pays each person, as the approver sees it (BE-PRODUCTS-10-S01): last four digits only.
export function accountLabel(emp) {
  return emp?.bank_last4 ? `•••• ${emp.bank_last4}` : "No bank details";
}

// Why a batch is back for approval, or "" when it is not.
export function reapprovalNote(batch) {
  const count = batch?.reapproval?.employee_count || 0;
  if (!count) return "";
  const who = count === 1 ? "1 person" : `${count} people`;
  return `Bank details changed for ${who} after this batch was made. Approving again pays the accounts shown here; revert the batch to use the new details.`;
}
